import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const DepreciationsListTable = ({
  children,
  company, ///////
  subcompany, ////////
  count,
  permissions, //////
  handleOrderChange = () => {},
  handleToggle = () => {}, ///////
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('depreciations.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('depreciations.fields.name') + ': ' },
    {
      variable: 'active',
      text: t('depreciations.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.depreciations.update',
    togglePermission: 'acl.depreciations.toggle',
    editUrl: 'depreciations', //Url para editar empleado
    propsName: 'depreciation', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };

  return (
    <Common.List dataCard={dataCard}>
      {/* //////////////////// */}
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('depreciations.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('depreciations.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('depreciations.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
      {/* //////////////////// */}
    </Common.List>
  );
};

export default translate()(DepreciationsListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/list/DepreciationsListTable.js